import LinkInfo from '@/components/LinkInfo/LinkInfo';
import Icon from '@/components/Icons/Icon';
import styles from './LinkedBundle.module.css';

export const LinkedBundle = () => (
  <div className={styles.confirmationBodyLinkedBundle}>
    <div className={styles.confirmationLinkedBundleIcon}>
      <div>
        <LinkInfo />
      </div>
      <div className={styles.confirmationLinkedBundleLabel}>
        Linked bundle - Changes will affect all linked bundles.
      </div>
    </div>
    <div className={styles.confirmationLinkedBundleOkIcon}>
      <Icon iconName="CheckCircle" size="46" />
    </div>
  </div>
);
